import React from 'react';
import s from './style.module.css';

class ContentHeader extends React.Component {

	render() {
		return (
			<div className={s.wrapper}>
				<div className={s.headline}>{this.props.value}</div>
			</div>
		);
	}
}


export default ContentHeader; 